import React, { useCallback, useMemo } from "react";
import styles from "./Styles.module.css";
import constants from "../../../../../config/constants";
import DataTables from "../../../../../Datatables/Datatable.table";
import useAssociatedProgramsListHook from "./AssociatedProgramsList.hook";
import StatusPill from "../../../../../components/Status/StatusPill.component";
import {  IconButton, Typography } from "@mui/material";
import {
    Edit, Info
} from "@mui/icons-material";
import useRoles from "../../../../../hooks/RoleHook";
import Constants from "../../../../../config/constants";
import FilterComponent from "../../../../../components/Filter/Filter.component";

const AssociatedProgramsListTable = ({}) => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    isCalling,
    data,
    currentData,
    currentPage,
    isFetching,
    handleDetail,
    handleSearchValueChange,
    handleFilterDataChange,
    configFilter
  } = useAssociatedProgramsListHook({});
  const { canRead} = useRoles(Constants.MODULES.ADMIN_USERS);
  const renderStatus = useCallback((status) => {
    if (status === "ACTIVE") {
      return <StatusPill status={"ACTIVE"} color={"active"} />;
    } else if (status === "INACTIVE") {
      return <StatusPill status={"INACTIVE"} color={"high"} />;
    } else if (status === "SCHEDULED") {
      return <StatusPill status={"SCHEDULED"} color={"medium"} />;
    }
  }, []);

  const tableStructure = useMemo(() => {
    return [
      {
        key: "title",
        label: "Program Name",
        sortable: false,
        render: (temp, all) => (
          <div>
            {all?.name}
          </div>
        ),
      },
      
      {
        key: "timestamp",
        label: "Dates",
        sortable: false,
        render: (temp, all) => <div>{all?.startDateText} - {all?.endDateText}</div>,
      },
      {
        key: "timestamp",
        label: "User Enrolled",
        sortable: false,
        render: (temp, all) => <div>{all?.enrolled_count}</div>,
      },
      {
        key: "status",
        label: "Status",
        sortable: false,
        render: (temp, all) => <div>{renderStatus(all?.status)}</div>,
      },
      // {
      //   key: "status",
      //   label: "Approval Status",
      //   sortable: false,
      //   render: (temp, all) => <div>{renderStatus(all?.status)}</div>,
      // },
      ...(canRead ? [{
        key: "user_id",
        label: "Action",
        render: (temp, all) => (
          <div className={styles.actionButton}>
           {canRead &&  <IconButton
      disableRipple="false"
      onClick={() => {
        
        handleDetail(all);
      }}
    >
      <Info
        fontSize={"small"}
       
      />
    </IconButton>}
            
          </div>
        ),
      },] : [])
    ];
  }, [isCalling, renderStatus]);

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    currentData,
    currentPage,
    data,
  ]); // allData,

  return (
    <div className={styles.mainContainer}>
      <div className={styles.row1}>
        <Typography
          variant={"h5"}
          className={styles.productHeading}
          color={"text.primary"}
        >
          {" "}
          Associated Programs
        </Typography>
        <FilterComponent
          // disabled={editData ? true : false}
          filters={[]}
          is_progress={false}
          // filters={configFilter}
         // handleFilterDataChange={handleFilterDataChange}
          handleSearchValueChange={handleSearchValueChange}
          placeholder="Search by program name"
        />
      </div>
      <br />
      <DataTables {...tableData.datatable} {...tableData.datatableFunctions} />
    </div>
  );
};

export default AssociatedProgramsListTable;
